
<h2 class="dialog-title">Configurações</h2>
<div class="dialog-content form-field-density-4">
    <nz-collapse [nzBordered]="true" class="headers-align">
        <nz-collapse-panel [nzHeader]="headerInfo" [nzShowArrow]="false" [nzActive]="step === 0" (nzActiveChange)="onPanelChange($event, 0, false)" *ngIf="showStep(0)">
            <ng-template #headerInfo>
                <div class="panel-header">
                    <span class="panel-title">Informações</span>
                    <span class="panel-desc">Dados do Campo <nz-icon nzType="info-circle"></nz-icon></span>
                </div>
            </ng-template>
            <div class="props-grid props-grid-4">
                <ng-container *ngIf="entityDesc!=null">
                    <div class="info-title">Desc. Entidade:</div>
                    <div class="info-desc">{{entityDesc}}</div>
                    <div class="info-title">Tabela:</div>
                    <div class="info-desc">{{entityName}}</div>
                </ng-container>
                <div class="info-title">Nome:</div>
                <div class="info-desc">{{entityName}}.{{information.COLUMNNAME}}</div>
                <div class="info-title">Descrição:</div>
                <div class="info-desc">{{information.COLUMNDESC}}</div>
                <div class="info-title">Tipo:</div>
                <div class="info-desc">{{information.DATATYPE}}</div>
                <div class="info-title">Tamanho:</div>
                <div class="info-desc">{{information.COLSIZE}}</div>
            </div>
        </nz-collapse-panel>

        <nz-collapse-panel [nzHeader]="headerPadroes" [nzShowArrow]="false" [nzActive]="step === 1" (nzActiveChange)="onPanelChange($event, 1, false)" *ngIf="showStep(1)">
            <ng-template #headerPadroes>
                <div class="panel-header" nz-tooltip="Atenção. As preferências definidas sobrescreverão a padrão do sistema.">
                    <span class="panel-title">Padrões</span>
                    <span class="panel-desc">Padrões do Campo <nz-icon nzType="control"></nz-icon></span>
                </div>
            </ng-template>

            <div class="ajuste-container">
                <nz-spin [nzSpinning]="prefLoading" nzSize="large">
                <div class="tem-field" *ngIf="uas.user.companylist.length > 1">
                    <label class="tem-field-label">Escolher uma Empresa</label>
                    <nz-select [(ngModel)]="codecompany" (ngModelChange)="loadProperties(codecompany)" nzPlaceHolder="Escolher uma Empresa">
                        <nz-option *ngFor="let data of uas.user.companylist" [nzValue]="data.codecompany" [nzLabel]="data.codecompany + ' - ' + data.companyname"></nz-option>
                    </nz-select>
                </div>
                <div class="props-grid props-grid-6" *ngIf="codecompany!=null">
                    <div class="info-title"><span class="data-name">Obrigatório:</span></div>
                    <div class="info-desc">
                        <nz-switch *ngIf="!requiredForm" [(ngModel)]="required" (ngModelChange)="onModelChange()"></nz-switch>
                        <button nz-button *ngIf="requiredForm" [nzDanger]="requiredText!=null" (click)="openFormula('required')">Expressão</button>
                    </div>
                    <div class="info-title"><span class="data-name">Somente Leitura:</span></div>
                    <div class="info-desc">
                        <nz-switch *ngIf="!readonlyForm" [(ngModel)]="readonly" (ngModelChange)="onModelChange()"></nz-switch>
                        <button nz-button *ngIf="readonlyForm" [nzDanger]="readonlyText!=null" (click)="openFormula('readonly')">Expressão</button>
                    </div>
                    <div class="info-title"><span class="data-name">Aceita Nulo:</span></div>
                    <div class="info-desc">
                        <nz-switch *ngIf="!nullableForm" [(ngModel)]="nullable" (ngModelChange)="onModelChange()"></nz-switch>
                        <button nz-button *ngIf="nullableForm" [nzDanger]="nullableText!=null" (click)="openFormula('nullable')">Expressão</button>
                    </div>
                    <div class="info-title"><span class="data-name">Descrição:</span></div>
                    <div class="info-desc">
                        <nz-input-group *ngIf="!descriptionForm" [nzSuffix]="clearDesc" class="right-confort-pad">
                            <input nz-input type="text" placeholder="Descrição" [(ngModel)]="description" (ngModelChange)="onModelChange()" [ngModelOptions]="{ updateOn: 'blur' }">
                        </nz-input-group>
                        <ng-template #clearDesc>
                            <nz-icon *ngIf="description" nzType="close-circle" class="clear-icon" (click)="description='';onModelChange()"></nz-icon>
                        </ng-template>
                        <button nz-button *ngIf="descriptionForm" [nzDanger]="descriptionText!=null" (click)="openFormula('description')">Expressão</button>
                    </div>
                    <div class="info-title"><span class="data-name">Valor Padrão:</span></div>
                    <div class="info-desc">
                        <nz-input-group *ngIf="!isSelectField && !defaultValueForm" [nzSuffix]="clearDefault" class="right-confort-pad">
                            <input nz-input type="text" placeholder="Valor Padrão" [(ngModel)]="defaultValue" (ngModelChange)="onModelChange()" [ngModelOptions]="{ updateOn: 'blur' }">
                        </nz-input-group>
                        <ng-template #clearDefault>
                            <nz-icon *ngIf="defaultValue" nzType="close-circle" class="clear-icon" (click)="defaultValue='';onModelChange()"></nz-icon>
                        </ng-template>
                        <nz-select *ngIf="isSelectField && !defaultValueForm" [(ngModel)]="defaultValue" (ngModelChange)="onModelChange()" nzPlaceHolder="Selecionar uma Opção" class="full-select">
                            <nz-option *ngFor="let data of selectedValues" [nzValue]="data.value" [nzLabel]="data.view"></nz-option>
                        </nz-select>
                        <button nz-button *ngIf="defaultValueForm" [nzDanger]="defaultValueText!=null" (click)="openFormula('defaultValue')">Expressão</button>
                    </div>
                    <div class="info-title"><span class="data-name">Decimais:</span></div>
                    <div class="info-desc">
                        <nz-input-group *ngIf="!decimalForm" [nzSuffix]="clearDecimal" class="right-confort-pad">
                            <input nz-input type="number" placeholder="Casas Decimais" [(ngModel)]="decimal" [disabled]="information.DATATYPE!='FLOAT'" (ngModelChange)="onModelChange()" [ngModelOptions]="{ updateOn: 'blur' }">
                        </nz-input-group>
                        <ng-template #clearDecimal>
                            <nz-icon *ngIf="decimal" nzType="close-circle" class="clear-icon" (click)="decimal='';onModelChange()"></nz-icon>
                        </ng-template>
                        <button nz-button *ngIf="decimalForm" [nzDanger]="decimalText!=null" (click)="openFormula('decimal')">Expressão</button>
                    </div>
                    <div class="info-title"><span class="data-name">Tamanho Mínimo:</span></div>
                    <div class="info-desc">
                        <nz-input-group *ngIf="!minLengthForm" [nzSuffix]="clearMin" class="right-confort-pad">
                            <input nz-input type="number" placeholder="Tamanho Mínimo" [(ngModel)]="minLength" [disabled]="information.DATATYPE=='FLOAT' || information.DATATYPE== 'INT'" (ngModelChange)="onModelChange()" [ngModelOptions]="{ updateOn: 'blur' }">
                        </nz-input-group>
                        <ng-template #clearMin>
                            <nz-icon *ngIf="minLength" nzType="close-circle" class="clear-icon" (click)="minLength='';onModelChange()"></nz-icon>
                        </ng-template>
                        <button nz-button *ngIf="minLengthForm" [nzDanger]="minLengthText!=null" (click)="openFormula('minLength')">Expressão</button>
                    </div>
                    <div class="info-title"><span class="data-name">Tamanho Máximo:</span></div>
                    <div class="info-desc">
                        <nz-input-group *ngIf="!maxLengthForm" [nzSuffix]="clearMax" class="right-confort-pad">
                            <input nz-input type="number" placeholder="Tamanho Máximo" [(ngModel)]="maxLength" [disabled]="information.DATATYPE=='FLOAT' || information.DATATYPE== 'INT'" (ngModelChange)="onModelChange()" [ngModelOptions]="{ updateOn: 'blur' }">
                        </nz-input-group>
                        <ng-template #clearMax>
                            <nz-icon *ngIf="maxLength" nzType="close-circle" class="clear-icon" (click)="maxLength='';onModelChange()"></nz-icon>
                        </ng-template>
                        <button nz-button *ngIf="maxLengthForm" [nzDanger]="maxLengthText!=null" (click)="openFormula('maxLength')">Expressão</button>
                    </div>
                    <div class="info-title"><span class="data-name">Expressão</span></div>
                    <div class="info-desc">
                        <button nz-button [nzDanger]="expressionText!=null" (click)="openFormula('expression')">Expressão</button>
                    </div>
                    <div class="info-title"><span class="data-name">Limpar ao Duplicar:</span></div>
                    <div class="info-desc">
                        <nz-switch [(ngModel)]="copyclean" (ngModelChange)="onModelChange()"></nz-switch>
                    </div>
                    <div class="info-title"><span class="data-name">Ajuda</span></div>
                    <div class="info-desc">
                        <button nz-button [nzDanger]="toolTipText!=null" (click)="openText()">Ajuda</button>
                    </div>
                </div>
                </nz-spin>
            </div>
        </nz-collapse-panel>

        <nz-collapse-panel [nzHeader]="headerAcoes" [nzShowArrow]="false" [nzActive]="step === 2" (nzActiveChange)="onPanelChange($event, 2, true)" *ngIf="showStep(2)">
            <ng-template #headerAcoes>
                <div class="panel-header">
                    <span class="panel-title">Ações</span>
                    <span class="panel-desc">Configurações de Ações <nz-icon nzType="thunderbolt"></nz-icon></span>
                </div>
            </ng-template>
            <ng-container *ngIf="showActions">
                <form-field-properties-detail-actions [entityName]="entityName" [prefName]="'get'+entityName.toUpperCase()+'.'+information.COLUMNNAME" [row]="row" ></form-field-properties-detail-actions>
            </ng-container>
        </nz-collapse-panel>
        <nz-collapse-panel [nzHeader]="headerAcoesSimples" [nzShowArrow]="false" [nzActive]="step === 3" (nzActiveChange)="onPanelChange($event, 3, true)" *ngIf="showStep(3)">
            <ng-template #headerAcoesSimples>
                <div class="panel-header">
                    <span class="panel-title">Ações de Inserção Rápida - Simples</span>
                    <span class="panel-desc">Configurações de Ações <nz-icon nzType="thunderbolt"></nz-icon></span>
                </div>
            </ng-template>
            <ng-container *ngIf="showActions">
                <form-field-properties-detail-actions [entityName]="entityName" [prefName]="'get'+entityName.toUpperCase()" [showParameter]="true"></form-field-properties-detail-actions>
            </ng-container>
        </nz-collapse-panel>
        <nz-collapse-panel [nzHeader]="headerAcoesMulti" [nzShowArrow]="false" [nzActive]="step === 4" (nzActiveChange)="onPanelChange($event, 4, true)" *ngIf="showStep(4)">
            <ng-template #headerAcoesMulti>
                <div class="panel-header">
                    <span class="panel-title">Ações de Inserção Rápida - Multi</span>
                    <span class="panel-desc">Configurações de Ações <nz-icon nzType="thunderbolt"></nz-icon></span>
                </div>
            </ng-template>
            <ng-container *ngIf="showActions">
                <form-field-properties-detail-actions [entityName]="entityName" [prefName]="'get'+entityName.toUpperCase()+'_COMPLEX'" [showParameter]="true"></form-field-properties-detail-actions>
            </ng-container>
        </nz-collapse-panel>
    </nz-collapse>
</div>
<div class="dialog-actions">
    <button nz-button nzType="primary" (click)="dialogRef.close(true)" cdkFocusInitial>Fechar</button>
</div>
